export const MUTATION_KEYS = {
  LOGIN: "login",
  CREATE_BILLING: "createBilling",
  UPDATE_BUDGET: "updateBudget",
  UPDATE_CONTRACT: "updateContract",
  CREATE_OSOS: "createOsos",
  UPDATE_OSOS: "updateOsos",
  CREATE_USER: "createUser",
  UPDATE_USER: "updateUser",
  CREATE_ALARM: "createAlarm",
  UPDATE_ALARM: "updateAlarm",
  UPDATE_ALARM_DESCRIPTION: "updateAlarmDescription",
  UPDATE_ALARM_STATE: "updateAlarmState",
  DELETE_ALARM: "deleteAlarm",
};
